import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth }  from '@/context/AuthContext'
import { useTheme } from '@/context/ThemeContext'
import LanguageSwitcher from '@/components/ui/LanguageSwitcher'
import { Pill, UserPill } from '@/components/aurora'
import { Moon, Sun, LogIn, ArrowUpRight, LogOut, LayoutDashboard } from 'lucide-react'

function Divider() {
  return (
    <div
      className="hidden sm:block w-px h-[18px] mx-1"
      style={{ background: 'var(--border)' }}
      aria-hidden="true"
    />
  )
}

export default function PublicHeader() {
  const { t }                   = useTranslation()
  const { user, isAuth, logout } = useAuth()
  const canAccessDashboard       = isAuth && user?.role !== 'guest'
  const { isDark, toggleTheme }  = useTheme()

  return (
    <header
      className="sticky top-0 z-20 w-full px-4 sm:px-8 py-3.5 flex items-center justify-between gap-3"
      style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}
    >
      <Link
        to="/"
        className="font-bold text-[20px] tracking-tight leading-none"
        style={{ color: 'var(--ink)', textDecoration: 'none' }}
      >
        5mi<span style={{ color: 'var(--coral)' }}>.</span>
        <span style={{ color: 'var(--ink-3)', fontWeight: 400 }}>uz</span>
      </Link>

      <nav className="flex items-center gap-1.5">
        {canAccessDashboard && (
          <>
            <Pill as={Link} to="/dashboard">
              <LayoutDashboard size={13} strokeWidth={2} />
              <span className="hidden sm:inline">Dashboard</span>
              <ArrowUpRight size={12} strokeWidth={2} />
            </Pill>
            <Divider />
          </>
        )}

        <LanguageSwitcher />
        <Pill
          iconOnly
          onClick={toggleTheme}
          title={isDark ? t('theme.light', "Yorug' rejim") : t('theme.dark', "Qorong'u rejim")}
          aria-label="Toggle theme"
        >
          {isDark ? <Sun size={14} strokeWidth={2} /> : <Moon size={14} strokeWidth={2} />}
        </Pill>

        {!isAuth && (
          <>
            <Divider />
            <Pill as={Link} to="/login" variant="cta">
              <LogIn size={14} strokeWidth={2} />
              <span className="hidden sm:inline">{t('auth.login', 'Kirish')}</span>
            </Pill>
          </>
        )}

        {isAuth && (
          <>
            <UserPill as={Link} to="/settings" user={user} />
            <Pill iconOnly onClick={logout} title={t('auth.logout', 'Chiqish')} aria-label="Chiqish">
              <LogOut size={14} strokeWidth={2} />
            </Pill>
          </>
        )}
      </nav>
    </header>
  )
}
